<template>
  <div class="input-typed-phone">
    <div class="input-typed-phone__row">
      <input-phone
        v-bind:title="title"
        v-bind:value="value"
        v-bind:violations="violations"
        v-on:invalid="onInvalid"
        v-on:incomplete-input="onInput(type, $event)"
      />
      <slot />
    </div>
    <input-checkbox
      title="Городской"
      v-bind:value="isCity"
      v-on:input="onInputType"
    />
  </div>
</template>

<script>
import InputCheckbox from '@/components/InputCheckbox.vue';
import InputPhone from '@/components/InputPhone.vue';

/**
 * @description Городской.
 * @type {string}
 */
const PHONE_TYPE_CITY = 'city';

/**
 * @description Сотовый.
 * @type {string}
 */
export const PHONE_TYPE_MOBILE = 'mobile';

/**
 * @description Компонент с выбором типа и вводом номера телефона.
 * @type {Vue}
 */
export default {
  components: { InputCheckbox, InputPhone },
  computed: {
    isCity() {
      return this.type === PHONE_TYPE_CITY;
    },
  },
  methods: {
    /**
     * @description Обработать ввод.
     * @param {string} type
     * @param {string} value
     * @returns {void}
     */
    onInput(type, value) {
      this.$emit('input', { type, value });
    },
    /**
     * @description Обработать некорректность поля.
     * @returns {void}
     */
    onInvalid() {
      this.$emit('invalid');
    },
    /**
     * @description Обработать ввод типа номера.
     * @param {boolean} value
     * @returns {void}
     */
    onInputType(value) {
      const newType = value ? PHONE_TYPE_CITY : PHONE_TYPE_MOBILE;
      this.onInput(newType, this.value);
    },
  },
  name: 'InputTypedPhone',
  props: {
    /**
     * @description Заголовок.
     */
    title: { default: 'Телефон', type: String },
    /**
     * @description Тип номера.
     */
    type: {
      required: true,
      type: String,
      validator: (input) => [PHONE_TYPE_CITY, PHONE_TYPE_MOBILE].indexOf(input) !== -1,
    },
    /**
     * @description Значение.
     */
    value: { required: true, type: String },
    /**
     * @description Список нарушений.
     */
    violations: { required: true, type: Array },
  },
};
</script>
<style lang="scss" scoped>
.input-typed-phone {
  display: flex;
  flex-direction: column;
  gap: 7px;

  &__row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 30px;
  }
}

@media screen and (max-width: 480px) {
  .input-typed-phone {
    &__row {
      flex-direction: column;
      gap: 15px;
      align-items: flex-start;
    }
  }
}
</style>
